import React from 'react';
import { useNavigate } from 'react-router-dom';

const WhatsHot = ({ products }) => {
  const navigate = useNavigate();

  // Ensure products is always an array
  const safeProducts = Array.isArray(products) ? products : [];

  return (
    <section className="py-2 bg-white">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl font-black mb-6 uppercase tracking-wide text-left px-16 lg:px-20">
          WHAT'S HOT
        </h2>
        
        <div className="relative group/carousel">
          {/* Left Arrow */}
          <button 
            onClick={(e) => {
              e.stopPropagation();
              document.querySelector('.whats-hot-carousel').scrollBy({ left: -320, behavior: 'smooth' });
            }}
            className="absolute left-16 top-1/2 -translate-y-1/2 z-10 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg opacity-0 group-hover/carousel:opacity-100 transition-opacity duration-300"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Right Arrow */}
          <button 
            onClick={(e) => {
              e.stopPropagation();
              document.querySelector('.whats-hot-carousel').scrollBy({ left: 320, behavior: 'smooth' });
            }}
            className="absolute right-16 top-1/2 -translate-y-1/2 z-10 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg opacity-0 group-hover/carousel:opacity-100 transition-opacity duration-300"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <div 
            className="whats-hot-carousel flex overflow-x-auto gap-2 scrollbar-hide pl-16 lg:pl-20"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {safeProducts.slice(0, 6).map((product) => (
              <div 
                key={product._id} 
                className="group cursor-pointer flex-none w-80" 
                onClick={() => navigate(`/product/${product._id}`)}
              >
                <div className="relative overflow-hidden mb-4 bg-gray-100">
                  <img 
                    src={product.image_url} 
                    alt={product.name}
                    className="w-full h-[500px] object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="space-y-2 text-left">
                  <h3 className="font-bold text-base uppercase tracking-tight leading-tight">{product.name}</h3>
                  <p className="text-gray-700 text-sm line-clamp-2 leading-relaxed">{product.description}</p>
                  <button className="text-sm font-bold underline hover:no-underline mt-3 block">
                    Shop Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsHot;
